import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { Doc } from "../../models";
import { FORM_CLEAR, FORM_END_PROCESSING } from "../../lib";
import { navigate, notification, eventEmitter } from "../../services";
import {
    DOC_FETCH_ALL,
    DOC_FETCH,
    DOC_SET,
    DOC_DESTROY,
    DOC_SAVE,
    DOC_REMOVE,
    DOC_CREATE,
    DOC_SET_MULTIPLE,
} from "./actions";
import { EVT_DOC_CREATE } from "../../components/Forms/DocForm";
import { AxiosResponse } from "axios";

function* fetchDocs(_action: { type: typeof DOC_FETCH_ALL }) {
    try {
        const {
            data: { count, rows },
        }: AxiosResponse<{ count: number; rows: Array<any> }> = yield call([
            Doc,
            "list",
        ]);
        if (count > 0) {
            yield put({
                type: DOC_SET_MULTIPLE,
                payload: rows,
            });
        }
    } catch (e) {}
}

function* onFetchDocs() {
    yield takeLatest(DOC_FETCH_ALL, fetchDocs);
}

function* fetchDoc(action: { type: typeof DOC_FETCH; payload: any }) {
    try {
        const { data }: AxiosResponse<{ id: number }> = yield call(
            [Doc, "fetch"],
            action.payload
        );
        yield put({
            type: DOC_SET,
            payload: {
                data,
                id: data.id,
            },
        });
    } catch (e) {}
}

function* onFetchDoc() {
    yield takeEvery(DOC_FETCH, fetchDoc);
}

function* createDoc(action: {
    type: typeof DOC_CREATE;
    payload: {
        redirect: boolean;
        [x: string]: any;
    };
}) {
    try {
        const {
            data,
        }: AxiosResponse<{
            doc: { id: number };
            page: { id: number };
        }> = yield call([Doc, "create"], action.payload);
        yield put({
            type: DOC_SET,
            payload: {
                data,
                id: data.doc.id,
            },
        });

        const {
            doc: { id: doc_id },
            page: { id: page_id },
        } = data;

        if (action.payload.redirect) {
            navigate.to(`/app/e/${doc_id}/${page_id}`);
        }

        eventEmitter.emit(FORM_END_PROCESSING);
        eventEmitter.emit(FORM_CLEAR);
        eventEmitter.emit(EVT_DOC_CREATE, {
            doc_id,
            page_id,
        });

        notification.set("doc.created", "s");
    } catch (e) {
        eventEmitter.emit(FORM_END_PROCESSING);
        notification.set("doc.failed", "f");
    }
}

function* onCreateDoc() {
    yield takeLatest(DOC_CREATE, createDoc);
}

function* saveDoc(action: {
    type: typeof DOC_SAVE;
    payload: {
        doc_id: string;
        data: any;
    };
}) {
    try {
        const { doc_id, data } = action.payload;
        const res: AxiosResponse<Array<any>> = yield call(
            [Doc, "save"],
            data,
            doc_id
        );
        yield put({
            type: DOC_SET,
            payload: {
                id: doc_id,
                data: res.data,
            },
        });
        eventEmitter.emit(FORM_END_PROCESSING);
        notification.set("doc.saved", "s");
    } catch (e) {
        eventEmitter.emit(FORM_END_PROCESSING);
        notification.set("doc.failed", "f");
    }
}

function* onSaveDoc() {
    yield takeLatest(DOC_SAVE, saveDoc);
}

function* destroyDoc(action: { type: typeof DOC_DESTROY; payload: any }) {
    try {
        yield call([Doc, "destroy"], action.payload);
        yield put({
            type: DOC_REMOVE,
            payload: { doc_id: action.payload },
        });
    } catch (e) {}
}

function* onDestroyDoc() {
    yield takeEvery(DOC_DESTROY, destroyDoc);
}

export { onFetchDoc, onFetchDocs, onCreateDoc, onSaveDoc, onDestroyDoc };
